<template>
  <!--
    P3 (student-foundation-redesign) -- Advisor Coming Soon destination for
    the Home advisor card. No advisor profiles, booking, calendar, payment,
    or promised response times -- there is no advisor backend at all.
  -->
  <!--
    SX-02 (doc 22 §5.1): the CTA no longer starts the teacher flow (Coming
    Soon itself); it points at the real AI Tutor, matching the body copy.
  -->
  <student-coming-soon-screen
    testid="student-advisor-view"
    icon="headset"
    :eyebrow="$t('studentComingSoon.advisor.eyebrow')"
    :heading="$t('studentComingSoon.advisor.heading')"
    :body="$t('studentComingSoon.advisor.body')"
    :cta-to="`/${$i18n.locale}/student/ai-tutor`"
    :cta-label="$t('studentComingSoon.aiTutorCta')"
  />
</template>

<script>
import StudentComingSoonScreen from '@/components/StudentHome/StudentComingSoonScreen.vue'

export default {
  name: 'StudentAdvisorView',
  components: { StudentComingSoonScreen },
}
</script>
